'use client';

export const Home = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M5.59417 27.9062H11.78V19.1029C11.78 18.7337 11.9049 18.4242 12.1546 18.1742C12.4046 17.9244 12.7142 17.7996 13.0833 17.7996H18.9167C19.2858 17.7996 19.5954 17.9244 19.8454 18.1742C20.0951 18.4242 20.22 18.7337 20.22 19.1029V27.9062H26.4058V12.5504C26.4058 12.4649 26.3872 12.3874 26.35 12.3179C26.3125 12.2485 26.2617 12.1871 26.1975 12.1337L16.3046 4.69582C16.219 4.62832 16.1175 4.59457 16 4.59457C15.8825 4.59457 15.781 4.62832 15.6954 4.69582L5.8025 12.1337C5.73833 12.1871 5.6875 12.2485 5.65 12.3179C5.61278 12.3874 5.59417 12.4649 5.59417 12.5504V27.9062ZM3.5 27.9062V12.5537C3.5 12.1362 3.59056 11.7446 3.77167 11.3787C3.95306 11.0126 4.21153 10.7099 4.54708 10.4704L14.44 3.01332C14.8894 2.66443 15.4071 2.48999 15.9929 2.48999C16.5787 2.48999 17.1011 2.66443 17.56 3.01332L27.4529 10.4704C27.7885 10.7099 28.0469 11.0126 28.2283 11.3787C28.4094 11.7446 28.5 12.1362 28.5 12.5537V27.9062C28.5 28.4762 28.2935 28.9678 27.8804 29.3808C27.4674 29.7939 26.9758 30.0004 26.4058 30.0004H19.4296C19.0601 30.0004 18.7506 29.8755 18.5008 29.6258C18.2511 29.3758 18.1263 29.0662 18.1263 28.6971V19.8933H13.8738V28.6971C13.8738 29.0662 13.7489 29.3758 13.4992 29.6258C13.2494 29.8755 12.9399 30.0004 12.5704 30.0004H5.59417C5.02417 30.0004 4.53264 29.7939 4.11958 29.3808C3.70653 28.9678 3.5 28.4762 3.5 27.9062Z"
				fill="currentColor"
			/>
		</svg>
	);
};
